import { takeLatest, put, call } from 'redux-saga/effects';

import { filterNotification } from '../service';
import { storage, path } from "@commons";
import {
  NEW_FILTER_NEXT_PAGE_NOTIFICATION,
  NEW_FILTER_NEXT_PAGE_NOTIFICATION_PENDING,
  NEW_FILTER_NEXT_PAGE_NOTIFICATION_SUCCESS,
  NEW_FILTER_NEXT_PAGE_NOTIFICATION_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_NOTIFICATION } from '@commons/consts';

function* sagaNewFilterNextPageNotification(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_NOTIFICATION_PENDING });

  try {
    const user = JSON.parse(storage.get(path.sessionUser));
    // const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_NOTIFICATION) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_NOTIFICATION)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const dominio = JSON.parse(storage.get(CONFIG_SESSION)).schemaSelecionado;
    const schema = dominio ? dominio : '';
    const propriedadeId = newFilter.propriedade ? newFilter.propriedade.id : ''; 
    const list = yield call(filterNotification, user.id, propriedadeId, schema, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_NOTIFICATION, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_NOTIFICATION_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_NOTIFICATION_FAILURE })
  }
}

export default function* watchNewFilterNextPageNotification() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_NOTIFICATION, sagaNewFilterNextPageNotification)
}
